module.exports = __webpack_public_path__ + "static/media/noprofile.697fdcd2.png";